<template>
  <div>
    <slot/>
    <div class="container mt-5">
      <hr/>
      <pre class="text-right text-muted">v{{version}}</pre>
    </div>
  </div>
</template>

<script>
export default {
  name: 'layout-no-nav',
  data() {
    return {
      version: process.env.version
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/no-nav.vue